import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "dots"]
  static values = { index: Number }

  connect() {
    this.indexValue = 0
    this.showSlide(this.indexValue)
  }

  next() {
    const nextIndex = (this.indexValue + 1) % this.slideTargets.length
    this.indexValue = nextIndex
    this.showSlide(nextIndex)
  }

  prev() {
    const prevIndex = (this.indexValue - 1 + this.slideTargets.length) % this.slideTargets.length
    this.indexValue = prevIndex
    this.showSlide(prevIndex)
  }

  goTo(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    this.indexValue = index
    this.showSlide(index)
  }

  showSlide(index) {
    this.slideTargets.forEach((slide, i) => {
      if (i === index) {
        // Active slide: relative position, visible
        slide.classList.remove("absolute", "inset-0", "opacity-0", "pointer-events-none")
        slide.classList.add("relative", "opacity-100")
        slide.style.visibility = ""
      } else {
        // Inactive slides: absolute position, hidden
        slide.classList.remove("relative", "opacity-100")
        slide.classList.add("absolute", "inset-0", "opacity-0", "pointer-events-none")
        slide.style.visibility = "hidden"
      }
    })

    if (this.hasDotsTarget) {
      this.dotsTarget.querySelectorAll("button").forEach((dot, i) => {
        if (i === index) {
          dot.classList.remove("bg-gray-300")
          dot.classList.add("bg-[#084572]")
        } else {
          dot.classList.remove("bg-[#084572]")
          dot.classList.add("bg-gray-300")
        }
      })
    }
  }
}
